import { Link } from "react-router-dom";
import { useFetchCities } from "../../../api/queries/homeQueries";
import { Swiper, SwiperSlide } from "swiper/react";
import { useTranslationEx } from "../../../hooks/useTranslationEx";
import "./RecommendCity.scss";

export const RecommendCities = () => {
  const {
    data: citiesData,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
  } = useFetchCities({});

  const { t2 } = useTranslationEx();

  if (isLoading) return <></>;

  const handleSlideChange = (swiper: any) => {
    const currentIndex = swiper.activeIndex;
    const totalSlides = citiesData?.pages.flatMap((page) => page).length || 0;
    console.log(totalSlides, currentIndex);
    // Trigger API call when user swipes near the end
    if (currentIndex >= totalSlides - 10 && !isFetchingNextPage) {
      fetchNextPage();
    }
  };

  return (
    <div className="recommend-cities-container">
      <Swiper
        className="recommend-cities-swiper"
        spaceBetween={8}
        onSlideChange={handleSlideChange}
        slidesPerView={"auto"}
      >
        {citiesData?.pages.flatMap((page) =>
          page.data.map(
            (city) =>
              city.shownCity && (
                <SwiperSlide className="recommend-cities-slide" key={city.id}>
                  <span className="recommend-cities-link-wrapper">
                    <Link
                      className="recommend-cities-link"
                      to={"/cities/" + city.slug}
                      key={city.id}
                    >
                      {t2(city.name)}
                    </Link>
                  </span>
                </SwiperSlide>
              ),
          ),
        )}
      </Swiper>
    </div>
  );
};
